// isFriendOfPlayer.js
import { db } from "@/firebase/config";
import { doc, getDoc } from "firebase/firestore";

const isFriendOfPlayer = async (hId, pId) => {
  try {
    // If your composite primary key uses a different joiner, adjust this line.
    const docId = `${hId}${pId}`;
    const ref = doc(db, "playerFriends", docId);
    const snap = await getDoc(ref);

    if (!snap.exists()) return false;

    const data = snap.data();
    return data?.friend === true;
  } catch (err) {
    console.error("isFriendOfPlayer error:", err);
    return false;
  }
};

export default isFriendOfPlayer;
